<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Portfolio" />
    </template>

    <div class="d-flex justify-content-between">
      <base-header>Co-Funded Loans</base-header>
      <div>
        <base-button secondary @click="downloadConsolidatedStatement">Consolidated Statement</base-button>
      </div>
    </div>
    <investment-consolidated-statement-pdf :statements.sync="consolidated" :user-investments.sync="userInvestments" />
    <user-investments />

    <div class="mt-5">
      <p class="font-weight-bold">Disclaimer</p>
      <p>
        The rates of return are ﬁxed by the investment but are dependent on investment performance and, as with all
        investments, you capital and returns are at risk when you invest. Please read the full
        <a href="https://saxontrust.com/risk-warning" target="_blank">risk warning here</a>.
      </p>
    </div>

    <template v-slot:bottom>
      <base-section light>
        <base-header>Transaction History</base-header>
        <user-transactions />
      </base-section>

    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'
import InvestmentConsolidatedStatementPdf from '@/components/InvestmentConsolidatedStatementPdf.vue'
import UserInvestments from '@/components/UserInvestments.vue'
import UserTransactions from '@/components/UserTransactions.vue'

export default {
  name: 'Portfolio',

  components: {
    HeroHeader,
    InvestmentConsolidatedStatementPdf,
    UserInvestments,
    UserTransactions
  },

  metaInfo: {
    title: 'Portfolio'
  },

  computed: {
    ...mapState({
      consolidated: store => store.core.investmentStatements.consolidated,
      userInvestments: store => store.core.userInvestments.all
    })
  },

  methods: {
    async downloadConsolidatedStatement () {
      await Promise.all([
        this.$store.dispatch('core/investment-statements/consolidated'),
        this.$store.dispatch('core/user-investments/all')
      ])

      this.$pdf.saveFromElement('investment-consolidated-statement-pdf', 'investment-consolidated-statement')
    }
  }
}
</script>
